import { TrayArrowUpIcon } from './TrayArrowUpIcon';

/**
 * author: arnoldlepineux
 * id C633DDA7-FB93-4041-98C2-92117B970114
 * name tray-arrow-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-arrow-up.svg
 * tags
 * - Arrow 
 */
export const TrayUploadIcon = TrayArrowUpIcon;
export default TrayUploadIcon